import DataTable from 'react-data-table-component';
import React, { useEffect, useState } from "react";
import { fetchStockParts } from '../../resources/AnalyticReportResource';

export default function StockPart() {
  const [dataStockParts, setDataStockParts] = useState([]);

  const fetchDataStockParts = () => {
    fetchStockParts()
      .then((res) => {
        setDataStockParts(res.data);
      })
      .catch((err) => {
        setDataStockParts([]);
      });
  };

  useEffect(() => {
    fetchDataStockParts();
  }, []);

  function convert_positive(a) {
    if (a < 0) {
      a = a * -1;
    }
    return a;
  }

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Part No',
      selector: row => row.name,
      sortable: true,
      width: '160px'
    },
    {
      name: 'Standard Stock',
      selector: row => row.standart_stock === null ? '-' : row.standart_stock,
      sortable: true,
    },
    {
      name: 'Stock Last Month',
      selector: row => row.stock_last_month,
      sortable: true,
    },
    {
      name: 'Inbound',
      selector: row => convert_positive(row.total_inbound),
      sortable: true,
    },
    {
      name: 'Outbound',
      selector: row => convert_positive(row.total_outbound),
      sortable: true,
    },
    {
      name: 'Current Stock',
      selector: row => row.current_stock,
      sortable: true,
    },
    {
      name: 'Status',
      width: '120px',
      selector: row =>
      (row.status === 'under' ? <a
        href="#section"
        className="btn btn-sm btn-light-danger btn-block radius-30"
      >
        {row.status}
      </a> : row.status === 'normal' ? <a
        href="#section"
        className="btn btn-sm btn-light-success btn-block radius-30"
      >
        {row.status}
      </a> : <a
        href="#section"
        className="btn btn-sm btn-light-warning btn-block radius-30"
      >
        {row.status}
      </a>),
      sortable: true,
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={dataStockParts}
    />
  );
}